import { useMemo } from "react";
import { PAGE_CONSTANTS } from "../components/au.mobile/car-detail-first-section/constants";

const useExtendedWarrantyCheck = (paymentSummaryData) => {
    return useMemo(() => {
        const { chargeDetails = [] } = paymentSummaryData || {};
        if (chargeDetails.length > 0) {
            const extendedWarrantyDetails =
                chargeDetails.find(
                    (val) =>
                        val.categoryKey === PAGE_CONSTANTS.EXTENDED_WARRANTY_PLAN ||
                        val.categoryKey === PAGE_CONSTANTS.CAR_COVER_BUNDLES
                ) || {};
            if (extendedWarrantyDetails && extendedWarrantyDetails?.vasPage === PAGE_CONSTANTS.VAS_PAGE) {
                return true;
            } else return false;
        } else return false;
    }, [paymentSummaryData]);
};

export default useExtendedWarrantyCheck;
